import { createAsyncThunk } from "@reduxjs/toolkit";

import { type AsyncThunkCreator } from "../../../index";
import { PRODUCT_CLIENT_REDUCER } from "../types";
import { getExtendAccessPeriodError, type ExtendAccessPeriodError } from "./extendAccessPeriodError";

type Payload =
  | {
      productId: string;
      clientEmail: string;
      resume_at: number | null;
      extensionType?: "freePeriodAfterEnd" | "pauseCollection";
    }
  | {
      productId: string;
      clientEmail: string;
      newBillingAnchor: number | null;
      keepPeriodEndAfterUpdateBillingAnchor: boolean;
    };

export const setExtendAccessPeriod = createAsyncThunk<void, Payload, AsyncThunkCreator<ExtendAccessPeriodError>>(
  `${PRODUCT_CLIENT_REDUCER}/setExtendAccessPeriod`,
  async (payload, { rejectWithValue, extra: { productApi, analytics } }) => {
    try {
      await productApi.post("/extend-client-access-period", payload);
      if ("resume_at" in payload && payload.resume_at !== null) {
        analytics.track("extend_access_period", {
          productId: payload.productId,
          clientEmail: payload.clientEmail,
          extendAbout: payload.resume_at,
        });
      } else if ("newBillingAnchor" in payload && payload.newBillingAnchor !== null) {
        analytics.track("change_billing_anchor", {
          productId: payload.productId,
          clientEmail: payload.clientEmail,
          extendAbout: payload.newBillingAnchor,
        });
      }
    } catch (e) {
      // A 409 carries a stable code + the Stripe status behind the refusal, so
      // the panel can say why instead of "contact support" (TRE-2048).
      return rejectWithValue(getExtendAccessPeriodError(e));
    }
  },
);
